// Highlights the active TOC item on the news & wissen details page
// based on which entry is currently in the viewport.

const SELECTOR_TOC_ITEM = '.newswissen-details__toc-item'
const SELECTOR_TOC_LINK = '.newswissen-details__toc-link'
const ACTIVE_CLASS = 'is-active'

const observers = []

function clearActive(items) {
	items.forEach((item) => {
		item.classList.remove(ACTIVE_CLASS)
	})
}

function setActiveById(items, targetId) {
	if (!targetId) {
		return
	}

	clearActive(items)

	const match = items.find((item) => {
		const link = item.querySelector(SELECTOR_TOC_LINK)
		if (!link) {
			return false
		}
		const href = link.getAttribute('href') || ''
		return href === `#${targetId}`
	})

	if (match) {
		match.classList.add(ACTIVE_CLASS)
	}
}

function setupToc(toc) {
	const items = Array.from(toc.querySelectorAll(SELECTOR_TOC_ITEM))

	if (!items.length) {
		return
	}

	const targets = items
		.map((item) => {
			const link = item.querySelector(SELECTOR_TOC_LINK)
			if (!link) {
				return null
			}
			const href = link.getAttribute('href') || ''
			if (!href.startsWith('#')) {
				return null
			}
			return document.getElementById(href.slice(1))
		})
		.filter(Boolean)

	if (!targets.length) {
		return
	}

	// Initial state — first item is active until the user scrolls
	items[0].classList.add(ACTIVE_CLASS)

	const visible = new Map()

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					visible.set(entry.target.id, entry.intersectionRatio)
				} else {
					visible.delete(entry.target.id)
				}
			})

			if (visible.size === 0) {
				return
			}

			let topId = null
			let topRatio = -1

			visible.forEach((ratio, id) => {
				if (ratio > topRatio) {
					topRatio = ratio
					topId = id
				}
			})

			setActiveById(items, topId)
		},
		{
			rootMargin: '-30% 0px -55% 0px',
			threshold: [0, 0.25, 0.5, 0.75, 1],
		}
	)

	targets.forEach((target) => observer.observe(target))
	observers.push(observer)

	// Make sure clicking a TOC link highlights it immediately
	toc.addEventListener('click', (event) => {
		const link = event.target.closest(SELECTOR_TOC_LINK)
		if (!link) {
			return
		}
		const href = link.getAttribute('href') || ''
		if (href.startsWith('#')) {
			setActiveById(items, href.slice(1))
		}
	})
}

export function newswissenToc() {
	if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
		return
	}

	// Disconnect any previous observers (e.g. on hot reload)
	while (observers.length) {
		observers.pop().disconnect()
	}

	const tocs = document.querySelectorAll('.newswissen-details__toc')
	tocs.forEach(setupToc)
}
